import { LANGUAGE_CODE } from 'shared/constants/language';
import React, { createContext, useState } from 'react';

export const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [smallSide, setSmallSide] = useState(false);
  const [floatApplyMedicalRelevance, setFloatApplyMedicalRelevance] = useState({
    show: false,
    data: null,
    action: null,
  });
  const [selectedComponents, setSelectedComponents] = useState([]);
  const [selectedComponentsSource, setSelectedComponentsSource] = useState();
  const [languageSelected, setLanguageSelected] = useState(() => {
    return localStorage.getItem('selectedLanguage') || LANGUAGE_CODE.ID;
  });

  return (
    <GlobalStateContext.Provider
      value={{
        smallSide,
        setSmallSide,
        floatApplyMedicalRelevance,
        setFloatApplyMedicalRelevance,
        selectedComponents,
        setSelectedComponents,
        selectedComponentsSource,
        setSelectedComponentsSource,
        languageSelected,
        setLanguageSelected,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};
